#import "@/components/common/LinkFragment.gql"
#import "@/components/common/CraftAssetFragment.gql"
#import "@/components/common/RoutinePreviewFragment.gql"

fragment FiftyFiftyTeaserFragment on fiftyFiftyTeaser_Entry {
  id
  typeHandle
  image {
    ...CraftAssetFragment
  }
  cta {
    ...LinkFragment
  }
  routine {
    ...RoutinePreviewFragment
  }
  mainHeading
  heading
  subtitle
  body

  imageRight
  useCompactLayout
  backgroundGray
  position
}
